import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAccountTierFileApi } from "../../../../../api/correspondent/CorresspondentApi";
import { useModal } from "../../../../../hooks";
import { AxiosError } from "axios";

/**
 * pta 티어파일 생성
 * @param param0
 * @returns
 */
const useCreateAccountPtaTierFile = () => {
  const { handleModal } = useModal();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: (data: FormData) => createAccountTierFileApi(data),
    onSuccess: (res: any) => {
      if (String(res?.code) === '0000') {
        queryClient.invalidateQueries({
          queryKey: ["readAccountTierInfo"],
        });
        handleModal({
          isOpen: true,
          contents: '파일이 저장되었습니다.',
          type: "confirm",
        });
        return;
      }
      handleModal({
        isOpen: true,
        contents: res?.data?.msg || '파일 저장에 실패했습니다.',
        type: "alert",
      });
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
      if (error?.response?.data?.msg) {
        handleModal({
          isOpen: true,
          contents: error?.response?.data?.msg,
          type: "alert",
        });
      }
    },
  });

  return { mutate };
};
export default useCreateAccountPtaTierFile;
